/*
 * @Descripttion: 工具类
 * @FilePath: /mall-wap-vue/src/utils/index.js
 * @Author: 张兴业
 * @Date: 2020-10-09 21:05:31
 * @LastEditors: hl
 * @LastEditTime: 2026-03-26 14:24:35
 */
import dayjs from "dayjs";
import jstz from "jstz";
import numeral from "numeral";
import { $G } from "@/global";
export function parseTime(time, cFormat) {
  if (arguments.length === 0 || !time) {
    return null;
  }
  const format = cFormat || "{y}-{m}-{d} {h}:{i}:{s}";
  let date;
  if (typeof time === "object") {
    date = time;
  } else {
    if (typeof time === "string") {
      if (/^[0-9]+$/.test(time)) {
        // support "1548221490638"
        time = parseInt(time);
      } else {
        // support safari
        // https://stackoverflow.com/questions/4310953/invalid-date-in-safari
        time = time.replace(new RegExp(/-/gm), "/");
      }
    }

    if (typeof time === "number" && time.toString().length === 10) {
      time = time * 1000;
    }
    date = new Date(time);
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  };
  const time_str = format.replace(/{([ymdhisa])+}/g, (result, key) => {
    const value = formatObj[key];
    // Note: getDay() returns 0 on Sunday
    if (key === "a") {
      return ["日", "一", "二", "三", "四", "五", "六"][value];
    }
    return value.toString().padStart(2, "0");
  });
  return time_str;
}
/**
 * @param {number} time
 * @param {string} option
 * @returns {string}
 */
export function formatTime(time, option) {
  if (("" + time).length === 10) {
    time = parseInt(time) * 1000;
  } else {
    time = +time;
  }
  const d = new Date(time);
  const now = Date.now();

  const diff = (now - d) / 1000;

  if (diff < 30) {
    return "刚刚";
  } else if (diff < 3600) {
    // less 1 hour
    return Math.ceil(diff / 60) + "分钟前";
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + "小时前";
  } else if (diff < 3600 * 24 * 2) {
    return "1天前";
  }
  if (option) {
    return parseTime(time, option);
  } else {
    return (
      d.getMonth() +
      1 +
      "月" +
      d.getDate() +
      "日" +
      d.getHours() +
      "时" +
      d.getMinutes() +
      "分"
    );
  }
}
//校验手机号
export function verifyPhone(prefix, phone) {
  //交由后端进行验证
  if (prefix === "+86") {
    const reg = /^(1[3456789])\d{9}$/;
    if (reg.test(phone)) {
      return true;
    }
    return false;
  }
  if (prefix === "+61") {
    const reg = /^(04|4)\d{8}$/;
    if (reg.test(phone)) {
      return true;
    }
    return false;
  }
  if (prefix === "+64") {
    const reg = /^(02|2)\d{8,10}$/;
    if (reg.test(phone)) {
      return true;
    }
    return false;
  }
  return false;
}

export function isWechatEnv() {
  var ua = navigator.userAgent.toLowerCase();
  var isWeixin = ua.indexOf("micromessenger") !== -1;
  return isWeixin;
}
/* 货币 */
export function currency(input, isCase = true, fixed = true) {
  const format = fixed ? "0.00" : "0.[00]";
  const str = `${numeral(input).format(format)}`;
  const prices = str.split(".");
  if (isCase && prices.length === 2) {
    return `<span style="font-size:12px;">${$G('symbol')}</span>${prices[0]}.<span style="font-size:12px;">${prices[1]}</span>`;
  }
  return `${$G('symbol')} ${numeral(input).format(format)}`;
}
/* 整形 */
export const intFormatter = new Intl.NumberFormat("en-AU", {
  style: "decimal",
  maximumFractionDigits: 0
});
/* 货币 */
export function currencyFormat(input, intOnly = true) {
  if (intOnly) {
    // Intl.NumberFormat currency 不支持小于两位小数位
    return `$ ${intFormatter.format(input)}`;
  }
  return new Intl.NumberFormat("zh-CN", {
    style: "currency",
    currency: "CNY",
    useGrouping: false,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(input);
}

// java 日期转换
/* 日期 */
/**
 *
 * @param {*} date
 * @param {*} format YYYY-MM-DD、YYYY-MM-DD HH:mm:ss等等
 */
export function dateFormatterJava(
  date,
  format = "YYYY-MM-DD HH:mm:ss",
  timezone = true
) {
  if (timezone) {
    const offset = jstz.determine().timezoneOffset();
    return dayjs(date)
      .add(-offset, "minute")
      .format(format);
  }
  return dayjs(date).format(format);
}
